/* ZIGZAG - page produit + sections (buy box, quiz, stock, prix bouton, vidéos, comparateur, avis) */
(function(){
'use strict';
var B='https://cdn.shopify.com/s/files/1/1051/4753/1596/files/';
var D=window.ZZ_DATA||{pad:[],mini:[],reviews:[]};
function img(f){return B+f;}
function money(c){return (c/100).toFixed(2).replace('.',',')+' €';}
function st(n,sm){var h="<span class='sf-tp"+(sm?" sf-tp--sm":"")+"'>";for(var i=0;i<5;i++){h+="<span class='sf-tp__s"+(i<n?"":" off")+"'>★</span>";}return h+"</span>";}
function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;');}
var OFFERS={
 '1 soutien-gorge':{sub:'Pour tester le confort Zigzag™',now:'19,90 €',was:'37,00 €'},
 'Lot de 3 (2+1 offert)':{sub:'3 pour le prix de 2 - Économisez 71,20 €',now:'39,80 €',was:'111,00 €',badge:'Le plus populaire ⭐'}
};
var UGC=[
 ['zz-ugc-01-sandrine.mp4','Sandrine','Bonnet E · 43 ans'],
 ['zz-ugc-02-julie.mp4','Julie','Bonnet E · 34 ans'],
 ['zz-ugc-03-brigitte.mp4','Brigitte','Bonnet F · 58 ans'],
 ['zz-ugc-04-yasmina.mp4','Yasmina','Bonnet F · 33 ans'],
 ['zz-ugc-05-fatou.mp4','Fatou','Bonnet G · 45 ans'],
 ['zz-ugc-06-laura.mp4','Laura','Bonnet E · 36 ans']
];
var LIVE=['zz-live-01.mp4','zz-live-02.mp4','zz-live-03.mp4','zz-live-04.mp4','zz-live-05.mp4','zz-live-06.mp4','zz-live-07.mp4','zz-live-08.mp4'];

/* ---------- BUY BOX ---------- */
function buyBox(){
 var info=document.querySelector('.product__info-container');
 if(!info||info.getAttribute('data-zz')) return;
 info.setAttribute('data-zz','1');
 /* note */
 var txt=info.querySelector('.product__text');
 if(txt&&/4,8\/5/.test(txt.textContent)){
  var r=document.createElement('div');r.className='sf-rate';
  r.innerHTML=st(5,1)+"<b>4,8/5</b><span>(2 147 avis vérifiés)</span>";
  txt.parentNode.replaceChild(r,txt);
 }
 /* tagline après le prix */
 var priceBox=info.querySelector('.product-page-price');
 if(priceBox&&!info.querySelector('.sf-tag')){
  priceBox.insertAdjacentHTML('afterend',"<p class='sf-tag'><strong>L’alternative n°1</strong> aux soutiens-gorges traditionnels à armatures</p>");
 }
 /* checklist : bloc bénéfices du thème -> sf-check */
 var eb=info.querySelector('.emoji-benefits-container');
 if(eb){
  var lines=eb.innerText.split('\n').map(function(s){return s.replace(/^[✓✔•\-\s]+/,'').trim();}).filter(Boolean);
  if(lines.length){var ch='';for(var q=0;q<lines.length;q++){ch+="<div class='sf-check__row'><span class='sf-check__box'>✓</span><span>"+esc(lines[q])+"</span></div>";}
   eb.innerHTML="<div class='sf-check'>"+ch+"</div>";}
 }
 /* quiz taille */
 var anchor=eb||info.querySelector('.sf-tag')||priceBox;
 if(anchor&&!info.querySelector('.sf-quiz')){
  anchor.insertAdjacentHTML('afterend',"<div class='sf-quiz'><p class='sf-quiz__t'>📏 Trouvez votre taille en 10 secondes</p><p class='sf-quiz__s'>Entrez votre taille de soutien-gorge habituelle</p><div class='sf-quiz__row'><select id='sfQTour' aria-label='Tour de dos'><option value=''>Tour</option><option value='80'>32 (80)</option><option value='85'>34 (85)</option><option value='90'>36 (90)</option><option value='95'>38 (95)</option><option value='100'>40 (100)</option><option value='105'>42 (105)</option><option value='110'>44 (110)</option></select><select id='sfQBonnet' aria-label='Bonnet'><option value=''>Bonnet</option><option>C</option><option>D</option><option>E</option><option>F</option><option>G</option></select><span class='sf-quiz__eq'>=</span><span class='sf-quiz__out' id='sfQOut'>?</span></div><p class='sf-quiz__res' id='sfQRes'>Sélectionnez votre tour de dos et votre bonnet</p></div>");
  var calc=function(){var t=document.getElementById('sfQTour').value,b=document.getElementById('sfQBonnet').value,out=document.getElementById('sfQOut'),res=document.getElementById('sfQRes');if(!t||!b){return;}
   var bands=['80','85','90','95','100','105','110'],cups=['C','D','E','F','G'];
   var s=bands.indexOf(t)+cups.indexOf(b);
   var SZ=['M','M','L','L','XL','XL','2XL','2XL','3XL','4XL','4XL'];
   var sz=SZ[Math.max(0,Math.min(10,s))];
   out.textContent=sz;res.className='sf-quiz__res is-ok';res.textContent='✓ Votre taille Zigzag : '+sz+' (sélectionnée pour vous)';
   var inp=info.querySelector("input[type=radio][name='Taille'][value='"+sz+"']");
   if(inp&&!inp.checked){inp.checked=true;inp.dispatchEvent(new Event('change',{bubbles:true}));}
  };
  document.getElementById('sfQTour').addEventListener('change',calc);
  document.getElementById('sfQBonnet').addEventListener('change',calc);
 }
 /* offre -> cartes */
 var fs=info.querySelectorAll('fieldset.product-form__input');
 for(var f=0;f<fs.length;f++){
  var leg=fs[f].querySelector('legend');
  if(!leg||!/^offre$/i.test(leg.textContent.trim())) continue;
  fs[f].classList.add('sf-offer');leg.textContent='Choisissez votre offre';
  var labels=fs[f].querySelectorAll('label');
  for(var l=0;l<labels.length;l++){
   var lb=labels[l],inpEl=document.getElementById(lb.getAttribute('for'));
   var name=(inpEl?inpEl.value:lb.textContent).trim();
   var o=OFFERS[name]||{sub:'',now:'',was:''};
   lb.className='sf-offer__card';
   lb.innerHTML="<span class='sf-offer__radio'></span><span class='sf-offer__body'><span class='sf-offer__name'>"+esc(name)+"</span><span class='sf-offer__sub'>"+esc(o.sub)+"</span></span><span class='sf-offer__price'><span class='sf-offer__now'>"+o.now+"</span><span class='sf-offer__was'>"+o.was+"</span></span>"+(o.badge?"<span class='sf-offer__badge'>"+o.badge+"</span>":"");
  }
 }
 /* ligne stock + date */
 var btns=info.querySelector('.product-form__buttons');
 if(btns&&!info.querySelector('.sf-stock')){
  var dlv=new Date(),nbiz=0;
  while(nbiz<4){dlv.setDate(dlv.getDate()+1);var wd=dlv.getDay();if(wd!==0&&wd!==6){nbiz++;}}
  var p2=function(x){return (x<10?'0':'')+x;};
  var ds=p2(dlv.getDate())+'/'+p2(dlv.getMonth()+1)+'/'+dlv.getFullYear();
  btns.insertAdjacentHTML('beforebegin',"<div class='sf-stock'><span class='sf-stock__dot'></span><span class='sf-stock__txt'>En stock · <span class='sf-stock__green'>Expédié sous 24h</span></span><span class='sf-stock__d'>- commandez aujourd’hui, recevez le <b>"+ds+"</b></span></div>");
  btns.insertAdjacentHTML('afterend',"<div class='sf-ticons'><div class='sf-ticons__i'><span>🚚</span>Livraison offerte</div><div class='sf-ticons__i'><span>🔒</span>Paiement sécurisé</div><div class='sf-ticons__i'><span>↩️</span>Satisfaite ou remboursée</div><div class='sf-ticons__i'><span>🇫🇷</span>SAV français</div></div>");
 }
 /* bloc échanges + mini avis avant la description */
 var desc=info.querySelector('.product__description');
 var pb=info.querySelector('.payment-badges-block');
 var ref=desc||null;
 if(ref&&!info.querySelector('.sf-exch')){
  var mh='';for(var m=0;m<D.mini.length;m++){mh+="<div class='sf-mini__item'><div class='sf-mini__head'>"+st(5,1)+"<span class='sf-mini__name'>"+esc(D.mini[m][0])+"</span><span class='sf-mini__ver'>✓ Achat vérifié</span></div><p class='sf-mini__txt'>"+esc(D.mini[m][1])+"</p></div>";}
  ref.insertAdjacentHTML('beforebegin',"<div class='sf-exch'><span class='sf-exch__ic'>🔁</span><div><p class='sf-exch__t'>Échanges gratuits sous 14 jours · satisfaite ou remboursée</p><p class='sf-exch__p'>Essayez Zigzag chez vous pendant 14 jours. Pas convaincue ? On vous rembourse ou on échange votre taille, sans justification, on s’occupe de tout.</p></div></div><div class='sf-mini'>"+mh+"</div>");
 }
 fixPrice();atcPrice();
 /* re-application après changement de variante (le thème re-rend prix + bouton) */
 var pi=info.closest('product-info')||info;
 var t=null;
 new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){fixPrice();atcPrice();},80);}).observe(pi,{childList:true,subtree:true,characterData:true});
 document.addEventListener('change',function(e){if(e.target&&e.target.name){setTimeout(function(){fixPrice();atcPrice();},150);setTimeout(atcPrice,600);}});
}
function fixPrice(){
 var info=document.querySelector('.product__info-container');if(!info)return;
 var bs=info.querySelectorAll('.price__badge-sale .nowrap, .price__badge-sale');
 for(var i=0;i<bs.length;i++){var b=bs[i];if(b.children.length&&b.tagName!=='SPAN')continue;var tx=b.textContent;if(/save/i.test(tx)){b.textContent=tx.replace(/save\s*/i,'-');}}
 var badge=info.querySelector('.product-page-price .price__badge-sale');
 if(badge&&!badge.parentNode.querySelector('.sf-offer-tag')){badge.insertAdjacentHTML('afterend',"<span class='sf-offer-tag'>Offre de rentrée</span>");}
}
function currentPrice(){
 var info=document.querySelector('.product__info-container');if(!info)return null;
 var pe=info.querySelector('.product-page-price .price__sale .price-item--sale')||info.querySelector('.product-page-price .price-item--regular');
 if(!pe)return null;
 var m=pe.textContent.replace(/\s/g,'').match(/(\d+[.,]\d{2})/);
 return m?m[1].replace('.',','):null;
}
function atcPrice(){
 var info=document.querySelector('.product__info-container');if(!info)return;
 var btn=info.querySelector('.product-form__buttons button[name=add]');if(!btn)return;
 var sp=btn.querySelector('span')||btn;
 var p=currentPrice();if(!p)return;
 var base=sp.textContent.replace(/\s*-\s*[\d.,]+\s*€\s*$/,'').trim();
 if(/épuisé|indisponible/i.test(base))return;
 var nt=base+' - '+p+' €';
 if(sp.textContent.trim()!==nt){sp.textContent=nt;}
}
/* total sur le bouton du cart drawer */
function cartBtn(){
 var cb=document.getElementById('CartDrawer-Checkout');if(!cb)return;
 fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
  if(!c||typeof c.total_price==='undefined')return;
  var base=cb.textContent.replace(/\s*-\s*[\d.,]+\s*€\s*$/,'').trim();
  var nt=c.item_count?base+' - '+money(c.total_price):base;
  if(cb.textContent.trim()!==nt){cb.textContent=nt;}
 }).catch(function(){});
}
function cartWatch(){
 var dr=document.querySelector('cart-drawer');if(!dr)return;
 var t=null;
 new MutationObserver(function(){clearTimeout(t);t=setTimeout(cartBtn,300);}).observe(dr,{childList:true,subtree:true});
 cartBtn();
}

/* ---------- SECTIONS ---------- */
function comparator(){
 var frames=document.querySelectorAll('.sf-ba__frame');
 for(var i=0;i<frames.length;i++){(function(fr){
  var af=fr.querySelector('.sf-ba__after'),ln=fr.querySelector('.sf-ba__line');if(!af||!ln)return;
  var setP=function(p){p=Math.max(2,Math.min(98,p));af.style.clipPath='inset(0 0 0 '+p+'%)';ln.style.left=p+'%';};
  var onMove=function(x){var r=fr.getBoundingClientRect();setP((x-r.left)/r.width*100);};
  var drag=false;
  fr.addEventListener('pointerdown',function(e){drag=true;try{fr.setPointerCapture(e.pointerId);}catch(err){}onMove(e.clientX);e.preventDefault();});
  fr.addEventListener('pointermove',function(e){if(drag){onMove(e.clientX);}});
  fr.addEventListener('pointerup',function(){drag=false;});
  fr.addEventListener('pointercancel',function(){drag=false;});
 })(frames[i]);}
}
function ugc(){
 var row=document.getElementById('sfVidsRow');if(!row)return;
 var h='';
 for(var k=0;k<UGC.length;k++){var it=UGC[k];
  h+="<div class='sf-vids__card'><video class='sf-vids__media' src='"+B+it[0]+"' preload='metadata' muted loop playsinline></video><button type='button' class='sf-vids__play' aria-label='Lire la vidéo'></button><span class='sf-vids__badge'><b>✓</b> VÉRIFIÉ</span><div class='sf-vids__meta'><p class='sf-vids__name'>"+it[1]+"</p><p class='sf-vids__info'>"+it[2]+"</p></div></div>";}
 row.innerHTML=h;
 row.addEventListener('click',function(e){var c=e.target.closest('.sf-vids__card');if(!c)return;
  var vid=c.querySelector('video'),pb=c.querySelector('.sf-vids__play');if(!vid)return;
  if(vid.paused){var all=row.querySelectorAll('video');for(var j=0;j<all.length;j++){if(all[j]!==vid&&!all[j].paused){all[j].pause();var op=all[j].parentNode.querySelector('.sf-vids__play');if(op)op.style.display='flex';}}
   vid.muted=true;vid.volume=0;var pr=vid.play();if(pr&&pr.catch)pr.catch(function(){});if(pb)pb.style.display='none';}
  else{vid.pause();if(pb)pb.style.display='flex';}
 });
 var prev=document.getElementById('sfVidsPrev'),next=document.getElementById('sfVidsNext');
 if(prev)prev.addEventListener('click',function(){row.scrollBy({left:-270,behavior:'smooth'});});
 if(next)next.addEventListener('click',function(){row.scrollBy({left:270,behavior:'smooth'});});
 var vs=document.getElementById('sfVidsStars');if(vs)vs.innerHTML=st(5,0);
}
function live(){
 var row=document.getElementById('sfActRow');if(!row)return;
 var h='';for(var n=0;n<LIVE.length;n++){h+="<div class='sf-act__card'><video class='sf-act__video' src='"+B+LIVE[n]+"' muted loop playsinline preload='metadata'></video><span class='sf-act__live'><i></i>LIVE</span></div>";}
 row.innerHTML=h;
 var avs=row.querySelectorAll('video');
 var play=function(v){v.muted=true;v.volume=0;var p=v.play();if(p&&p.catch)p.catch(function(){});};
 if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){play(en.target);}else{en.target.pause();}});},{threshold:.15});
  for(var i=0;i<avs.length;i++)io.observe(avs[i]);
 }else{for(var j=0;j<avs.length;j++)play(avs[j]);}
}
function padopt(){
 var g=document.getElementById('sfPadoptGrid');if(!g)return;
 var h='';for(var m=0;m<D.pad.length;m++){var pd=D.pad[m];
  h+="<div class='sf-padopt__card'><img class='sf-padopt__photo' loading='lazy' src='"+img(pd[0])+"' alt='Photo cliente Zigzag'/><div class='sf-padopt__body'><p class='sf-padopt__text'>"+pd[1]+"</p><div class='sf-padopt__meta'>"+st(5,1)+"<span class='sf-padopt__verified'><b>✓</b> Vérifié</span></div><div class='sf-padopt__who'><span class='sf-padopt__name'>"+pd[2]+"</span><span class='sf-padopt__fr'>FR</span></div></div></div>";}
 g.innerHTML=h;
 var s=document.getElementById('sfPadoptStars');if(s)s.innerHTML=st(5,0);
}
function wall(){
 var grid=document.getElementById('sfAvisGrid');if(!grid)return;
 var R=D.reviews,shown=0,STEP=12;
 function card(r){
  var h="<div class='sf-avis__card'>";
  if(r[6]){h+="<img class='sf-avis__photo' loading='lazy' src='"+img(r[6])+"' alt='Photo de la cliente'/>";}
  h+=st(r[2],1)+"<p class='sf-avis__rtitle'>"+r[3]+"</p><p class='sf-avis__text'>"+r[4]+"</p>";
  h+="<div class='sf-avis__foot'><span><span class='sf-avis__name'>"+r[0]+"</span><span class='sf-avis__size'>"+r[5]+" · "+r[1]+"</span></span><span class='sf-avis__verified'><b>✓</b> Achat vérifié</span></div>";
  if(r[7]){h+="<div class='sf-avis__reply'><strong>Réponse de Zigzag</strong><br>"+r[7]+"</div>";}
  return h+"</div>";
 }
 function more(){var h='',m=Math.min(shown+STEP,R.length);for(var i=shown;i<m;i++){h+=card(R[i]);}grid.insertAdjacentHTML('beforeend',h);shown=m;var b=document.getElementById('sfAvisMore');if(b){if(shown>=R.length){b.style.display='none';}else{b.textContent='Voir plus d’avis ('+(R.length-shown)+' restants)';}}}
 var ph=[];for(var i=0;i<R.length;i++){if(R[i][6])ph.push(R[i][6]);}
 for(var k=0;k<D.pad.length&&ph.length<10;k++){if(ph.indexOf(D.pad[k][0])<0)ph.push(D.pad[k][0]);}
 var sh='';for(i=0;i<ph.length;i++){sh+="<img loading='lazy' src='"+img(ph[i])+"' alt='Photo cliente Zigzag'/>";}
 var strip=document.getElementById('sfAvisStrip');if(strip)strip.innerHTML=sh;
 var ts=document.getElementById('sfAvisTopStars');if(ts)ts.innerHTML=st(5,0);
 var mb=document.getElementById('sfAvisMore');if(mb)mb.addEventListener('click',more);
 var vp=document.getElementById('sfAvisVoirPlus');if(vp)vp.addEventListener('click',function(e){e.preventDefault();more();});
 more();
}
function ctas(){
 var b=document.querySelectorAll('.sf-scrolltop');
 for(var i=0;i<b.length;i++){b[i].addEventListener('click',function(e){e.preventDefault();window.scrollTo({top:0,behavior:'smooth'});});}
}
function trustFirst(){
 var mg=document.querySelector('media-gallery');if(!mg||typeof mg.setActiveMedia!=='function')return;
 var li=mg.querySelector('[data-media-id$="-76001021329740"]');if(!li)return;
 var id=li.getAttribute('data-media-id');
 var vw=mg.querySelector('[id^="GalleryViewer"]');
 if(vw&&vw.querySelector('[data-media-id]')===li)return;
 mg.setActiveMedia(id,true);
}
function init(){
 try{buyBox();}catch(e){}
 try{trustFirst();}catch(e){}
 try{cartWatch();}catch(e){}
 try{comparator();}catch(e){}
 try{ugc();}catch(e){}
 try{live();}catch(e){}
 try{padopt();}catch(e){}
 try{wall();}catch(e){}
 try{ctas();}catch(e){}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
